'use strict';
import template from './landing-page.component.html';

export default {
	bindings: {},
	controller: MxLandingPageCtrl,
	controllerAs: 'vm',
	template: template,
};

MxLandingPageCtrl.$inject = [
	'$scope',
	'$q',
	'mx.shell.EventService',
	'mx.shell.NotificationService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'mx.SolutionBuilderAgent.DataModelService',
	'mx.shell.ContextService',
	'mx.shell.AppsService',
	'mx.shell.NavigationService',
	'mx.shell.ActionManagerService',
	'mx.shell.ActionExecutorService',
	'mx.shell.NavigationItemsLoaderService',
	'mx.shell.RoutingService',
	'mx.SolutionBuilderAgent.FavouritesService',
	'mx.SolutionBuilderAgent.DeepLinkingService',
];

export function MxLandingPageCtrl(
	$scope,
	$q,
	eventService,
	notificationService,
	i18n,
	contentWidgetService,
	dataModelService,
	contextService,
	applicationService,
	navigationService,
	actionManagerService,
	actionExecutorService,
	navigationItemsLoaderService,
	routingService,
	favouritesService,
	deepLinkingService
) {
	const vm = this;
	vm.navigationService = navigationService;
	vm.favouritesService = favouritesService;

	var freeDataSourceDefer = $q.defer();

	vm.$onInit = function () {
		var currentState = routingService.getCurrent();
		if (!currentState) {
			return;
		}

		var navigationId = (currentState.parameters.navigationId || '').toLowerCase();

		navigationService.getNavigationItem(navigationId).then(function (navigationItem) {
			if (!navigationItem) {
				var viewOptions = deepLinkingService.parseViewOptionsFromUrl();
				if (viewOptions) {
					routingService.goToDefault(viewOptions);
					return $q.when(null);
				} else {
					mx.console.error('Landing page navigation item is not found!');
					routingService.go('404');
					return $q.reject('no-navigation-item');
				}
			}

			applicationService.getWindowTitle().then(function (windowTitle) {
				if (navigationItem) {
					document.title = i18n.getFormatted('solutionBuilderAgent.pageTitle.landingPage', navigationItem.title, windowTitle);
				} else {
					document.title = windowTitle;
				}
			});

			vm.contentWidgetIdFromNavigation = navigationItem.contentWidgetId;
			eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ReloadLandingPage);
		});
	};

	var displayMode = mx.shell.DisplayMode.Normal;

	var processKeyUp = function (ev) {
		if (ev.which === 27) {
			$scope.$evalAsync(function () {
				displayMode = mx.shell.DisplayMode.Normal;
				vm.isBigScreen = false;
				eventService.dispatchEvent(mx.shell.EventCodes.DisplayModeChanged, displayMode);
			});
		}
	};

	$(document).on('keyup.landing_page', processKeyUp);

	$scope.$on('$destroy', function cleanUp() {
		if (vm.isBigScreen) {
			vm.switchMode();
		}
		$(document).unbind('keyup.landing_page');

		freeDataSourceDefer.resolve(true);
	});

	eventService.subscribeTo(
		mx.SolutionBuilderAgent.Events.SearchPageDataChanged,
		function () {
			eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ReloadLandingPage);
		},
		$scope
	);

	eventService.subscribeTo(
		mx.SolutionBuilderAgent.Events.ReloadLandingPage,
		function (eventObj, landingPageId) {
			initLanding(landingPageId || vm.contentWidgetIdFromNavigation);
		},
		$scope
	);

	eventService.subscribeTo(
		mx.shell.EventCodes.ActionsContextChanged,
		function (eventObj, context) {
			var actionTypes = [mx.shell.ActionContextType.None];

			if (context && context.uiZone === mx.shell.ActionUiZone.LandingPage) {
				actionManagerService
					.getActions(context, actionTypes, [])
					.then(function (actions) {
						return actionManagerService.filterActions(actions);
					})
					.then(function (filteredActions) {
						vm.commonActions = filteredActions;
					});
			}
		},
		$scope
	);

	vm.executeAction = executeAction;

	vm.switchMode = function () {
		displayMode = displayMode === mx.shell.DisplayMode.Normal ? mx.shell.DisplayMode.BigScreen : mx.shell.DisplayMode.Normal;
		vm.isBigScreen = displayMode === mx.shell.DisplayMode.BigScreen;
		eventService.dispatchEvent(mx.shell.EventCodes.DisplayModeChanged, displayMode);
		if (vm.isBigScreen) {
			notificationService.info(i18n.get('solutionBuilderAgent.layouts.landing-page.exitBigScreenMessage'));
		}
	};

	function initLanding(contentWidgetId) {
		if (!contentWidgetId) {
			return;
		}
		vm.loaded = false;

		return contentWidgetService
			.getHtml(contentWidgetId)
			.then(function (data) {
				vm.widget = {
					id: data.Id,
					extensions: data.Template.DataModelExtensions ? JSON.parse(data.Template.DataModelExtensions) || {} : {},
					views: data.Template.Views,
				};

				vm.nonVisualTemplate = data.Template.NonVisualTemplate;

				if (Array.isArray(data.Template.Views) && data.Template.Views.length > 0) {
					vm.view = data.Template.Views[0];
					vm.view.isLandingPage = true;
					vm.view.widgetId = vm.widget.id;

					vm.serviceContextInfo = {
						widgetId: vm.view.widgetId,
						viewName: vm.view.Key,
					};
				} else {
					mx.console.warn('No views for landing page');
				}

				vm.enablePersonalization = data.EnablePersonalization;

				return dataModelService.loadDataModel(vm.widget.extensions, { Context: { WidgetId: contentWidgetId } }, undefined, freeDataSourceDefer.promise);
			})
			.then(function (filledObject) {
				vm.dataModel = filledObject;
				contextService.val('SolutionBuilderAgent.LandingPageDataModel', vm.dataModel);

				if (!vm.enablePersonalization) {
					contextService.actionsContext = new mx.shell.ActionsContext([], [], mx.shell.ActionUiZone.LandingPage);
				} else {
					contextService.actionsContext = new mx.shell.ActionsContext(
						['PDRContentWidgetTypeLandingPage'],
						contextService.actionsContext ? contextService.actionsContext.extraActions : [],
						mx.shell.ActionUiZone.LandingPage
					);
				}

				return contentWidgetService.isCustomizable({ isLandingPage: true });
			})
			.then(
				function (isCustomizable) {
					if (isCustomizable) {
						vm.isCustomizable = true;
						vm.configure = function () {
							contentWidgetService.openConfigurePreview(vm.view);
						};
					}

					vm.loaded = true;
				},
				function (error) {
					vm.errorMessage = error && (error.message || error);
					vm.errorTitle = error && error.title;
					$q.reject(error);
				}
			);
	}

	function executeAction(action) {
		actionExecutorService.execute(action).catch(mx.logCatch);
	}
}
